"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pageDescriptorUrlPath = exports.pageDescriptorRegistry = void 0;
const BlogBoardPage_page_json_1 = __importDefault(require("./pages/BlogBoardPage.page.json"));
const BlogEditPage_page_json_1 = __importDefault(require("./pages/BlogEditPage.page.json"));
const BlogMessagePage_page_json_1 = __importDefault(require("./pages/BlogMessagePage.page.json"));
const BlogPostPage_page_json_1 = __importDefault(require("./pages/BlogPostPage.page.json"));
const BlogReplyPage_page_json_1 = __importDefault(require("./pages/BlogReplyPage.page.json"));
const CategoryPage_page_json_1 = __importDefault(require("./pages/CategoryPage.page.json"));
const CommunityPage_page_json_1 = __importDefault(require("./pages/CommunityPage.page.json"));
const PostPage_page_json_1 = __importDefault(require("./pages/PostPage.page.json"));
const TermsOfServicePage_page_json_1 = __importDefault(require("./pages/TermsOfServicePage.page.json"));
const SearchResultsPage_page_json_1 = __importDefault(require("./pages/SearchResultsPage.page.json"));
const ManageContentPage_page_json_1 = __importDefault(require("./pages/ManageContentPage.page.json"));
const PageEditorPage_page_json_1 = __importDefault(require("./pages/PageEditorPage.page.json"));
const ThemeEditorPage_page_json_1 = __importDefault(require("./pages/ThemeEditorPage.page.json"));
const HealthCheckPage_page_json_1 = __importDefault(require("./pages/HealthCheckPage.page.json"));
const HelpFAQPage_page_json_1 = __importDefault(require("./pages/HelpFAQPage.page.json"));
const BlogViewAllPostsPage_page_json_1 = __importDefault(require("./pages/BlogViewAllPostsPage.page.json"));
const ForumViewAllTopicsPage_page_json_1 = __importDefault(require("./pages/ForumViewAllTopicsPage.page.json"));
const TkbViewAllArticlesPage_page_json_1 = __importDefault(require("./pages/TkbViewAllArticlesPage.page.json"));
const IdeaViewAllIdeasPage_page_json_1 = __importDefault(require("./pages/IdeaViewAllIdeasPage.page.json"));
const ForumBoardPage_page_json_1 = __importDefault(require("./pages/ForumBoardPage.page.json"));
const ForumEditPage_page_json_1 = __importDefault(require("./pages/ForumEditPage.page.json"));
const ForumMessagePage_page_json_1 = __importDefault(require("./pages/ForumMessagePage.page.json"));
const ForumPostPage_page_json_1 = __importDefault(require("./pages/ForumPostPage.page.json"));
const ForumReplyPage_page_json_1 = __importDefault(require("./pages/ForumReplyPage.page.json"));
const ClosedMembershipNodeNonMembersPage_page_json_1 = __importDefault(require("./pages/ClosedMembershipNodeNonMembersPage.page.json"));
const CreateGroupHubPage_page_json_1 = __importDefault(require("./pages/CreateGroupHubPage.page.json"));
const EditGroupHubPage_page_json_1 = __importDefault(require("./pages/EditGroupHubPage.page.json"));
const GroupHubMembershipAction_page_json_1 = __importDefault(require("./pages/GroupHubMembershipAction.page.json"));
const GroupHubPage_page_json_1 = __importDefault(require("./pages/GroupHubPage.page.json"));
const GroupHubPostPage_page_json_1 = __importDefault(require("./pages/GroupHubPostPage.page.json"));
const GroupHubsPage_page_json_1 = __importDefault(require("./pages/GroupHubsPage.page.json"));
const ManageMembersPage_page_json_1 = __importDefault(require("./pages/ManageMembersPage.page.json"));
const IdeaBoardPage_page_json_1 = __importDefault(require("./pages/IdeaBoardPage.page.json"));
const IdeaEditPage_page_json_1 = __importDefault(require("./pages/IdeaEditPage.page.json"));
const IdeaMessagePage_page_json_1 = __importDefault(require("./pages/IdeaMessagePage.page.json"));
const IdeaPostPage_page_json_1 = __importDefault(require("./pages/IdeaPostPage.page.json"));
const IdeaReplyPage_page_json_1 = __importDefault(require("./pages/IdeaReplyPage.page.json"));
const InboxPage_page_json_1 = __importDefault(require("./pages/InboxPage.page.json"));
const EventBoardPage_page_json_1 = __importDefault(require("./pages/EventBoardPage.page.json"));
const EventPostPage_page_json_1 = __importDefault(require("./pages/EventPostPage.page.json"));
const TagPage_page_json_1 = __importDefault(require("./pages/TagPage.page.json"));
const TkbBoardPage_page_json_1 = __importDefault(require("./pages/TkbBoardPage.page.json"));
const TkbEditPage_page_json_1 = __importDefault(require("./pages/TkbEditPage.page.json"));
const TkbMessagePage_page_json_1 = __importDefault(require("./pages/TkbMessagePage.page.json"));
const TkbPostPage_page_json_1 = __importDefault(require("./pages/TkbPostPage.page.json"));
const TkbReplyPage_page_json_1 = __importDefault(require("./pages/TkbReplyPage.page.json"));
const ForgotPasswordPage_page_json_1 = __importDefault(require("./pages/ForgotPasswordPage.page.json"));
const LoginPage_page_json_1 = __importDefault(require("./pages/LoginPage.page.json"));
const RegistrationPage_page_json_1 = __importDefault(require("./pages/RegistrationPage.page.json"));
const ResetPasswordPage_page_json_1 = __importDefault(require("./pages/ResetPasswordPage.page.json"));
const VerifyUserEmailPage_page_json_1 = __importDefault(require("./pages/VerifyUserEmailPage.page.json"));
const ManageUsersPage_page_json_1 = __importDefault(require("./pages/ManageUsersPage.page.json"));
const UserPage_page_json_1 = __importDefault(require("./pages/UserPage.page.json"));
const UserSettingsPage_page_json_1 = __importDefault(require("./pages/UserSettingsPage.page.json"));
const NotificationPage_page_json_1 = __importDefault(require("./pages/NotificationPage.page.json"));
const OccasionMessagePage_page_json_1 = __importDefault(require("./pages/OccasionMessagePage.page.json"));
const OccasionReplyPage_page_json_1 = __importDefault(require("./pages/OccasionReplyPage.page.json"));
const AllOccasionsPage_page_json_1 = __importDefault(require("./pages/AllOccasionsPage.page.json"));
const OccasionEditPage_page_json_1 = __importDefault(require("./pages/OccasionEditPage.page.json"));
const CasePortalPage_page_json_1 = __importDefault(require("./pages/CasePortalPage.page.json"));
const CaseCreatePage_page_json_1 = __importDefault(require("./pages/CaseCreatePage.page.json"));
const CaseViewPage_page_json_1 = __importDefault(require("./pages/CaseViewPage.page.json"));
const UserBadgesPage_page_json_1 = __importDefault(require("./pages/UserBadgesPage.page.json"));
const OccasionRsvpActionPage_page_json_1 = __importDefault(require("./pages/OccasionRsvpActionPage.page.json"));
const OAuthAuthorizationAllowPage_page_json_1 = __importDefault(require("./pages/OAuthAuthorizationAllowPage.page.json"));
const CommunityGuideLinesPage_page_json_1 = __importDefault(require("./pages/CommunityGuideLinesPage.page.json"));
const PrivacyPolicyPage_page_json_1 = __importDefault(require("./pages/PrivacyPolicyPage.page.json"));
const MaintenancePage_page_json_1 = __importDefault(require("./pages/MaintenancePage.page.json"));
const WorkstreamsPage_page_json_1 = __importDefault(require("./pages/WorkstreamsPage.page.json"));
exports.pageDescriptorRegistry = {
    BlogBoardPage: BlogBoardPage_page_json_1.default,
    BlogEditPage: BlogEditPage_page_json_1.default,
    BlogMessagePage: BlogMessagePage_page_json_1.default,
    BlogPostPage: BlogPostPage_page_json_1.default,
    BlogReplyPage: BlogReplyPage_page_json_1.default,
    BlogViewAllPostsPage: BlogViewAllPostsPage_page_json_1.default,
    CategoryPage: CategoryPage_page_json_1.default,
    ClosedMembershipNodeNonMembersPage: ClosedMembershipNodeNonMembersPage_page_json_1.default,
    CommunityPage: CommunityPage_page_json_1.default,
    CreateGroupHubPage: CreateGroupHubPage_page_json_1.default,
    EditGroupHubPage: EditGroupHubPage_page_json_1.default,
    EventBoardPage: EventBoardPage_page_json_1.default,
    EventPostPage: EventPostPage_page_json_1.default,
    ForgotPasswordPage: ForgotPasswordPage_page_json_1.default,
    ForumBoardPage: ForumBoardPage_page_json_1.default,
    ForumEditPage: ForumEditPage_page_json_1.default,
    ForumMessagePage: ForumMessagePage_page_json_1.default,
    ForumPostPage: ForumPostPage_page_json_1.default,
    ForumReplyPage: ForumReplyPage_page_json_1.default,
    ForumViewAllTopicsPage: ForumViewAllTopicsPage_page_json_1.default,
    GroupHubMembershipAction: GroupHubMembershipAction_page_json_1.default,
    GroupHubPage: GroupHubPage_page_json_1.default,
    GroupHubPostPage: GroupHubPostPage_page_json_1.default,
    GroupHubsPage: GroupHubsPage_page_json_1.default,
    HealthCheckPage: HealthCheckPage_page_json_1.default,
    HelpFAQPage: HelpFAQPage_page_json_1.default,
    IdeaBoardPage: IdeaBoardPage_page_json_1.default,
    IdeaEditPage: IdeaEditPage_page_json_1.default,
    IdeaMessagePage: IdeaMessagePage_page_json_1.default,
    IdeaPostPage: IdeaPostPage_page_json_1.default,
    IdeaReplyPage: IdeaReplyPage_page_json_1.default,
    IdeaViewAllIdeasPage: IdeaViewAllIdeasPage_page_json_1.default,
    InboxPage: InboxPage_page_json_1.default,
    LoginPage: LoginPage_page_json_1.default,
    ManageContentPage: ManageContentPage_page_json_1.default,
    ManageMembersPage: ManageMembersPage_page_json_1.default,
    ManageUsersPage: ManageUsersPage_page_json_1.default,
    NotificationPage: NotificationPage_page_json_1.default,
    PageEditorPage: PageEditorPage_page_json_1.default,
    PostPage: PostPage_page_json_1.default,
    RegistrationPage: RegistrationPage_page_json_1.default,
    ResetPasswordPage: ResetPasswordPage_page_json_1.default,
    SearchResultsPage: SearchResultsPage_page_json_1.default,
    TagPage: TagPage_page_json_1.default,
    TermsOfServicePage: TermsOfServicePage_page_json_1.default,
    ThemeEditorPage: ThemeEditorPage_page_json_1.default,
    TkbBoardPage: TkbBoardPage_page_json_1.default,
    TkbEditPage: TkbEditPage_page_json_1.default,
    TkbMessagePage: TkbMessagePage_page_json_1.default,
    TkbPostPage: TkbPostPage_page_json_1.default,
    TkbReplyPage: TkbReplyPage_page_json_1.default,
    TkbViewAllArticlesPage: TkbViewAllArticlesPage_page_json_1.default,
    UserBadgesPage: UserBadgesPage_page_json_1.default,
    UserPage: UserPage_page_json_1.default,
    UserSettingsPage: UserSettingsPage_page_json_1.default,
    VerifyUserEmailPage: VerifyUserEmailPage_page_json_1.default,
    OccasionMessagePage: OccasionMessagePage_page_json_1.default,
    OccasionReplyPage: OccasionReplyPage_page_json_1.default,
    AllOccasionsPage: AllOccasionsPage_page_json_1.default,
    OccasionEditPage: OccasionEditPage_page_json_1.default,
    CasePortalPage: CasePortalPage_page_json_1.default,
    CaseCreatePage: CaseCreatePage_page_json_1.default,
    CaseViewPage: CaseViewPage_page_json_1.default,
    OccasionRsvpActionPage: OccasionRsvpActionPage_page_json_1.default,
    OAuthAuthorizationAllowPage: OAuthAuthorizationAllowPage_page_json_1.default,
    CommunityGuideLinesPage: CommunityGuideLinesPage_page_json_1.default,
    PrivacyPolicyPage: PrivacyPolicyPage_page_json_1.default,
    MaintenancePage: MaintenancePage_page_json_1.default,
    WorkstreamsPage: WorkstreamsPage_page_json_1.default
};
/**
 * Returns the url path for a specific entity type.
 *
 * @param endUserPage end user page
 */
function getUrlPathForPage(endUserPage) {
    const pageDescriptorFile = exports.pageDescriptorRegistry[endUserPage];
    if (pageDescriptorFile) {
        const pageDescriptor = pageDescriptorFile;
        const pageDefaultUrlPath = pageDescriptor.urlPath;
        if (!pageDefaultUrlPath) {
            throw new Error(`Missing url path for page: ${endUserPage}`);
        }
        return pageDefaultUrlPath;
    }
    throw new Error(`Missing page: ${endUserPage}`);
}
exports.pageDescriptorUrlPath = {
    BlogBoardPage: getUrlPathForPage('BlogBoardPage'),
    BlogEditPage: getUrlPathForPage('BlogEditPage'),
    BlogMessagePage: getUrlPathForPage('BlogMessagePage'),
    BlogPostPage: getUrlPathForPage('BlogPostPage'),
    BlogReplyPage: getUrlPathForPage('BlogReplyPage'),
    BlogViewAllPostsPage: getUrlPathForPage('BlogViewAllPostsPage'),
    CategoryPage: getUrlPathForPage('CategoryPage'),
    ClosedMembershipNodeNonMembersPage: getUrlPathForPage('ClosedMembershipNodeNonMembersPage'),
    CommunityPage: getUrlPathForPage('CommunityPage'),
    CreateGroupHubPage: getUrlPathForPage('CreateGroupHubPage'),
    CasePortalPage: getUrlPathForPage('CasePortalPage'),
    EditGroupHubPage: getUrlPathForPage('EditGroupHubPage'),
    EventBoardPage: getUrlPathForPage('EventBoardPage'),
    EventPostPage: getUrlPathForPage('EventPostPage'),
    ForgotPasswordPage: getUrlPathForPage('ForgotPasswordPage'),
    ForumBoardPage: getUrlPathForPage('ForumBoardPage'),
    ForumEditPage: getUrlPathForPage('ForumEditPage'),
    ForumMessagePage: getUrlPathForPage('ForumMessagePage'),
    ForumPostPage: getUrlPathForPage('ForumPostPage'),
    ForumReplyPage: getUrlPathForPage('ForumReplyPage'),
    ForumViewAllTopicsPage: getUrlPathForPage('ForumViewAllTopicsPage'),
    GroupHubMembershipAction: getUrlPathForPage('GroupHubMembershipAction'),
    GroupHubPage: getUrlPathForPage('GroupHubPage'),
    GroupHubPostPage: getUrlPathForPage('GroupHubPostPage'),
    GroupHubsPage: getUrlPathForPage('GroupHubsPage'),
    HealthCheckPage: getUrlPathForPage('HealthCheckPage'),
    HelpFAQPage: getUrlPathForPage('HelpFAQPage'),
    IdeaBoardPage: getUrlPathForPage('IdeaBoardPage'),
    IdeaEditPage: getUrlPathForPage('IdeaEditPage'),
    IdeaMessagePage: getUrlPathForPage('IdeaMessagePage'),
    IdeaPostPage: getUrlPathForPage('IdeaPostPage'),
    IdeaReplyPage: getUrlPathForPage('IdeaReplyPage'),
    InboxPage: getUrlPathForPage('InboxPage'),
    LoginPage: getUrlPathForPage('LoginPage'),
    ManageContentPage: getUrlPathForPage('ManageContentPage'),
    ManageMembersPage: getUrlPathForPage('ManageMembersPage'),
    ManageUsersPage: getUrlPathForPage('ManageUsersPage'),
    NotificationPage: getUrlPathForPage('NotificationPage'),
    PageEditorPage: getUrlPathForPage('PageEditorPage'),
    PostPage: getUrlPathForPage('PostPage'),
    RegistrationPage: getUrlPathForPage('RegistrationPage'),
    ResetPasswordPage: getUrlPathForPage('ResetPasswordPage'),
    SearchResultsPage: getUrlPathForPage('SearchResultsPage'),
    TagPage: getUrlPathForPage('TagPage'),
    TermsOfServicePage: getUrlPathForPage('TermsOfServicePage'),
    ThemeEditorPage: getUrlPathForPage('ThemeEditorPage'),
    TkbBoardPage: getUrlPathForPage('TkbBoardPage'),
    TkbEditPage: getUrlPathForPage('TkbEditPage'),
    TkbMessagePage: getUrlPathForPage('TkbMessagePage'),
    TkbPostPage: getUrlPathForPage('TkbPostPage'),
    TkbReplyPage: getUrlPathForPage('TkbReplyPage'),
    TkbViewAllArticlesPage: getUrlPathForPage('TkbViewAllArticlesPage'),
    IdeaViewAllIdeasPage: getUrlPathForPage('IdeaViewAllIdeasPage'),
    UserBadgesPage: getUrlPathForPage('UserBadgesPage'),
    UserPage: getUrlPathForPage('UserPage'),
    UserSettingsPage: getUrlPathForPage('UserSettingsPage'),
    VerifyUserEmailPage: getUrlPathForPage('VerifyUserEmailPage'),
    OccasionMessagePage: getUrlPathForPage('OccasionMessagePage'),
    OccasionReplyPage: getUrlPathForPage('OccasionReplyPage'),
    AllOccasionsPage: getUrlPathForPage('AllOccasionsPage'),
    OccasionEditPage: getUrlPathForPage('OccasionEditPage'),
    CaseCreatePage: getUrlPathForPage('CaseCreatePage'),
    CaseViewPage: getUrlPathForPage('CaseViewPage'),
    OccasionRsvpActionPage: getUrlPathForPage('OccasionRsvpActionPage'),
    OAuthAuthorizationAllowPage: getUrlPathForPage('OAuthAuthorizationAllowPage'),
    MaintenancePage: getUrlPathForPage('MaintenancePage'),
    CommunityGuideLinesPage: getUrlPathForPage('CommunityGuideLinesPage'),
    PrivacyPolicyPage: getUrlPathForPage('PrivacyPolicyPage'),
    WorkstreamsPage: getUrlPathForPage('WorkstreamsPage')
};
//# sourceMappingURL=PageDescriptorRoute.js.map